// extracted by mini-css-extract-plugin
export default {"section":"PopupSection_section__OHed+"};